import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoProduct } from 'app/shared/models/position/dto-product.model';
import { IDtoBudgetList } from 'app/shared/models/quote/dto-budget-list.model';
import { BudgetService } from 'app/views/appviews/quote/budget.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoBudget } from 'app/shared/models/quote/budget.model';

@Component({
    selector: 'app-modal-duplicate-budget',
    styleUrls: ['./modal-duplicate.style.scss'],
    templateUrl: './modal-duplicate.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalDuplicateBudgetComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formDuplicate: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */
    public onClose: Subject<boolean>;
    /**Variables */
    private product: IDtoProduct;
    private action: string;
    private budget: IDtoBudgetList;
    /**Catalogos */
    private catalogProductTypes: Observable<IDtoCatalog[]>;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private budgetService: BudgetService
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private identityService: IdentityService) {
        this.initializeFormDuplicate();
    }
    ngOnInit(): void {
        this.onClose = new Subject();
    }
    private initializeFormDuplicate() {
        this.formDuplicate = this.formBuilder.group({
            duration: [null, [Validators.required, Validators.maxLength(2)]],
            isReplace: [false],
            comments: [null]
        });
    }
    private submit(): void {
        if (this.formDuplicate.valid) {
            this.save();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
        }
    }
    private save(): void {
        let dto = this.formDuplicate.value as IDtoBudgetList;
        if (this.budget.statusName == 'Sustituida' && dto.isReplace) {
            this.configGeneral.newToast('Validación', 'No es posible generar versión de presupuesto cancelado. Seleccione la versión final de este presupuesto', 'warning');
            return;
        }
        this.spinner.show();
        dto.id = this.budget.id;
        dto.version = this.budget.version;
        this.budgetService.duplicateBudget(dto).subscribe(x => {
            if (this.configGeneral.notificationSuccessError(x)) {
                let dtoNew = x.data as IDtoBudget;
                if (dto.isReplace) {
                    this.addModuleLog(dto.id, 'replaced');
                } else {
                    this.addModuleLog(dto.id, 'duplicate');
                }
                this.addModuleLog(dtoNew.id, 'new');
                this.onClose.next(x.isCorrect);
                this.bsModalRef.hide();
            }
        },
        (errMessage) => this.errorMessages = errMessage.messages)
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Budgets';
        dto.module = 'budgets';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
